export default "__VITE_ASSET__26d6b071__"